<template>
  <h2>Dale2</h2>
</template>

<script>
export default {

}
</script>

<style>

</style>